import {IRootState} from "../../store/store";
import {getUserProfileApi} from "../api/get_user_profile";
import {IUserProfile} from "../types/IUserProfile";

export const selectUserProfileData = (state: IRootState): IUserProfile | null => {
    const cachedQuery = getUserProfileApi.endpoints.getUserProfile.select(undefined)(state);
    return cachedQuery.isSuccess && !!cachedQuery.data ? cachedQuery.data : null;
};
import {IRootState} from "../../store/store";
import {getUserProfileApi} from "../api/get_user_profile";
import {IUserProfile} from "../types/IUserProfile";

export const selectUserProfileData = (state: IRootState): IUserProfile | null => {
    const cachedQuery = getUserProfileApi.endpoints.getUserProfile.select(undefined)(state);
    return cachedQuery.isSuccess && !!cachedQuery.data ? cachedQuery.data : null;
};
